<span class="text-3xl">{{ 'activityTracker.title' | translate }}</span>

<p>{{ 'activityTracker.description' | translate }}</p>
<button
  kendoButton
  themeColor="primary"
  class="uppercase"
  maximizerShowcaseBookDemo
>
  {{ 'activityTracker.button.action' | translate }}
</button>
